import { IMRBaseComponent } from "../../../../../../../common/base"

import { OPERATOR_SECURITY_SERVICE_NAME } from "../../../../../../../../services/operator"
import { USER_SESSION_SERVICE_NAME } from "../../../../../../../../services/user-session"
import { REFERENCE_TYPE_SERVICE_NAME } from "../../../../../../../../services/reference-type"
import { GRID_SERVICE_NAME } from "../../../../../../../../services/grid"

import { OperatorDetailsSecurityRolesController } from "./operator-details.security.custom.controller"

//#region Asset Imports

import './operator-details.security.custom.scss'
import * as TEMPLATE from './operator-details.security.custom.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'operatorDetailsSecurityCustom'

export class OperatorDetailsSecurityCustomComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: OperatorDetailsSecurityRolesController,
            services: [
                GRID_SERVICE_NAME,
                OPERATOR_SECURITY_SERVICE_NAME,
                REFERENCE_TYPE_SERVICE_NAME,
                USER_SESSION_SERVICE_NAME
            ],
            template: TEMPLATE
        })
    }
}